import React from 'react';
import { NavigationBarRoutesMenu } from '../NavigationBarRoutesMenu/NavigationBarRoutesMenu';
import { NavigationSubmenu } from '../NavigationSubmenu/NavigationSubmenu';
// Apply the props type
export const renderSubmenuContent = ({ submenuState, routes, topOptions, options, visibleRoutesCount, currentPath, onNavigate, setSubmenuClosed }) => {
    if (!submenuState.active)
        return null;
    const { type, index } = submenuState.active;
    switch (type) {
        case 'route':
            return (React.createElement(NavigationBarRoutesMenu, { "data-testid": "navigation-bar-routes-menu", route: routes[index], currentPath: currentPath, onNavigate: onNavigate, onClose: setSubmenuClosed }));
        case 'topOption':
            return (React.createElement(NavigationSubmenu, { title: topOptions[index].name, onClose: setSubmenuClosed }, topOptions[index].menu));
        case 'option':
            return (React.createElement(NavigationSubmenu, { title: options[index].name, onClose: setSubmenuClosed }, options[index].menu));
        case 'overflowed': {
            /* Get the overflowed routes */
            /* Slice the routes to get the overflowed routes */
            const overflowedRoutes = routes.slice(visibleRoutesCount).map(route => (Object.assign(Object.assign({}, route), { icon: route.icon })));
            return (React.createElement(NavigationBarRoutesMenu, { "data-testid": "navigation-bar-routes-menu", route: {
                    /* Create a dummy route for the "More" button */
                    icon: null,
                    name: 'More',
                    path: '/more-options',
                    /* Pass the overflowed routes as children */
                    children: overflowedRoutes.map(route => {
                        if (route.children) {
                            return Object.assign(Object.assign({}, route), { 
                                /* Set the path to undefined for routes with children */
                                /* otherwise the route will be treated as a leaf node */
                                path: undefined });
                        }
                        /* Return the route of the parent */
                        return route;
                    })
                }, currentPath: currentPath, onNavigate: onNavigate, onClose: setSubmenuClosed }));
        }
        default:
            return null;
    }
};
//# sourceMappingURL=renderSubmenuContext.js.map